export const theme = {
  colors: {
    d4: '#10191D',
    d3: '#171F29',
    d2: '#192831',
    d1: '#1C2A37',
    ac1: '#26FFA1',
    l1: '#D5FFED',
    l2: '#EDFFF7',
  },
  glassBlur: '6px',
  glassBlurHover: '10px',
  glassBg: 'rgba(28,42,55,0.35)',
  glassBorder: 'rgba(255,255,255,0.07)',
  tickSize: '10px',
  tickOpacityRest: '0.15',
  tickOpacityHover: '0.40',
  fontFamily: "'JetBrains Mono', ui-monospace, monospace",
  fontFamilyContent: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontWeight: '300',
  uiLetterSpacing: '0.10em',
  hairline: 'rgba(255,255,255,0.07)',
  dividerInset: '10%',
  transitionFast: '0.15s ease',
  transitionSlow: '0.4s ease',
};
